import { render, staticRenderFns } from "./CreatorDetailCompetition.vue?vue&type=template&id=ca9261bc&scoped=true"
import script from "./CreatorDetailCompetition.vue?vue&type=script&lang=js"
export * from "./CreatorDetailCompetition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9261bc",
  null
  
)

export default component.exports